<div [formGroup]="formGroup" class="flex flex-col w-full" *transloco="let t">
  <mat-form-field [appearance]="appearance" class="fuse-mat-dense flex-auto">
    @if (label) {
      <mat-label>{{ (translateLabel ? t(label) : label) | capitalize }}</mat-label>
    }
    <mat-select [formControlName]="controlName" [compareWith]="selectedCompare" [multiple]="multiple">
      @if (multiple && compactMultipleTrigger) {
        <mat-select-trigger>
          <span class="block min-w-0 truncate">
            {{ isAllSelected && showSelectAll ? (t(selectAllLabel) | capitalize) : selectedMultipleSummary }}
          </span>
        </mat-select-trigger>
      }

      @if (showEmptyOption) {
        <mat-option value>
          <!-- Se não for informado um placeholder a opção vazia deve ser uma string vazia -->
          {{ (emptyOptionText ? t(emptyOptionText) : null) | capitalize }}
        </mat-option>
      }

      <!-- "Todos" é cabeçalho do painel, não uma opção: como `mat-option` ele renderizava o checkbox
           do próprio option em cima deste e disputava o valor do controle a cada clique. -->
      @if (multiple && showSelectAll) {
        <div
          class="flex cursor-pointer items-center gap-2 border-b border-gray-200 px-4 py-2 dark:border-gray-700"
          role="button"
          tabindex="0"
          (click)="toggleSelectAll()"
          (keydown.enter)="toggleSelectAll()"
          (keydown.space)="toggleSelectAll()"
        >
          <mat-checkbox color="primary" class="pointer-events-none" [checked]="isAllSelected"></mat-checkbox>
          <span class="font-medium">{{ t(selectAllLabel) | capitalize }}</span>
        </div>
      }

      <!-- Observable options -->
      @if (optionsType === 'observable') {
        @for (option of options$ | async; track option?.name) {
          <mat-option [value]="option?.value" (click)="selectedOptionEmitter(option?.value)">
            @if (!capitalize) {
              {{ optionTranslate ? t(option?.name || '') : option?.name }}
            } @else {
              {{ (optionTranslate ? t(option?.name || '') : option?.name) | capitalize }}
            }
          </mat-option>
        }
      } @else {
        <!-- Object Options -->
        @for (option of optionsAsArray; track option.name) {
          <mat-option [value]="option?.value" (click)="selectedOptionEmitter(option?.value)">
            @if (!capitalize) {
              {{ optionTranslate ? t(option?.name ?? '') : option?.name }}
            } @else {
              {{ (optionTranslate ? t(option?.name ?? '') : option?.name) | capitalize }}
            }
          </mat-option>
        }
      }
    </mat-select>
    @if (validateField.hasErrorValidate(formControl, 'required')) {
      <mat-error>{{ t('required-field') }}</mat-error>
    }
  </mat-form-field>
</div>
